import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class MotivoReunionService {

  controller: string = "motivo-reunion/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  insert(motivoReunion: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create', motivoReunion, this.sesion.headers);
  }

  update(motivoReunion: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update/' + motivoReunion.id, motivoReunion, this.sesion.headers);
  }

  view(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "view/" + id, this.sesion.headers);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "delete/" + id, this.sesion.headers);
  }

  select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'select', this.sesion.headers);
  }

  selectAnonimo(sucursalId: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'select-anonimo/' + sucursalId, this.sesion.headersAnonimo);
  }

  activate(id: number): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `activate/${id}`, {}, this.sesion.headers);
  }

  deactivate(id: number): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `deactivate/${id}`, {}, this.sesion.headers);
  }
}
